var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseConfirmPasswordFormComponent } from '@app/components/_shared/account/base-confirm-password-form/base-confirm-password-form.component';
var RightOfAccessComponent = /** @class */ (function (_super) {
    __extends(RightOfAccessComponent, _super);
    function RightOfAccessComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.locale = {};
        // BaseManagePasswordComponent template variables to be passed
        _this.templateSettings = {};
        return _this;
    }
    RightOfAccessComponent.prototype.ngOnInit = function () {
        this.locale = this.localisation.getTranslationsForComponent('RightOfAccessComponent');
        this.templateSettings = {
            header: this.locale.header,
            formParagraph: this.locale.formParagraph,
            submit: this.locale.submit
        };
    };
    RightOfAccessComponent.route = 'account/right-of-access';
    return RightOfAccessComponent;
}(BaseConfirmPasswordFormComponent));
export { RightOfAccessComponent };



// WEBPACK FOOTER //
// ./src/app/components/account/right-of-access/right-of-access.component.ts.pre-build-optimizer.js